// services/jobService.js
// Author: Harshada Bhavsar (18/7/2025)
// API: Create Job Opening for Employee
import axios from "../axios";
import Cookies from "js-cookie";

export const createJobOpening = async (jobData) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Jobs/Employee/CreateJobOpening", {
    ...jobData,
    token,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar (19/7/2025)
// API: Created Job Opening for Employee
export const getCreatedJobs = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Jobs/Employee/GetCreatedJobs", {
    token,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar (22/7/2025)
// API: Get Job Details for Employee
export const getJobDetails = async (jobUID) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/Jobs/Employee/GetJobDetails", {
    token,
    jobUID,
  });
};

// services/jobService.js
// Author: Sanket Raut 23-july-2025
// API: Get All Publish Jobs
export const getPublishJobs = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Jobs/Employee/GetPublishedJobs", {
    token,
  });
};


// services/jobService.js
// Author:  Sanket Raut 23-july-2025
// API: Get Publish Jobs by JobUID
export const getPublishJobsByUID = async (jobUID) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/Jobs/Employee/PublishJob", {
    token,
    jobUID,
  });
};


// services/jobService.js
// Author: Harshada Bhavsar 23-july-2025
// API: Get Sent Candidates Jobs
export const getSentCandidates = async () => {
  const token = Cookies.get("ConsultantToken");

  return axios.post("/api/Consultant/GetSentCandidates", {
    token,
  });
};


// services/jobService.js
// Author:Sanket Raut 24-july-2025
// API: Get Sent DashBoard Count
export const GetDashBoardData = async () => {
   const token = Cookies.get("employeeToken");

  return axios.post("/api/Jobs/GetDashboardData", {
    token,
  });
};

// services/jobService.js
// Author:Sanket Raut 24-july-2025
// API: Get Sent DashBoard Count
export const GetConsultantDashBoardData = async () => {
   const token = Cookies.get("ConsultantToken");

  return axios.post("/api/Consultant/GetDashboardData", {
    token
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 1-8-2025
// API: Get Sent Candidates For Jobs
export const getSentCandidateforJob = async (jobUID) => {
  const token = Cookies.get("ConsultantToken");
  return axios.post("/api/Consultant/GetSentCandidatesForJob", {
    token,
    jobUID,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 18-08-2025
// API: Assign Job To Employee
export const assignJobToEmployee = async (jobUID, employeeCode, token) => {
  return await axios.post("/api/Jobs/AssignJobToEmployee", {
    token,
    jobUID,
    employeeCode,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 18-08-2025
// API: Assign Job To Consultant
export const assignJobToConsultant = async (jobUID, consultantCode, token) => {
  return await axios.post("/api/Jobs/AssignJobToConsultant", {
    token,
    jobUID,
    consultantCode,
  });
};


export const VerifyCandidate = async (payload) => {
  const formData = new FormData();

  // Append form fields
  formData.append("CandidateName", payload.CandidateName);
  formData.append("CandidateEmail", payload.CandidateEmail);
  formData.append("CandidatePhoneNo", payload.CandidatePhoneNo);
  formData.append("CandidatePAN", payload.CandidatePAN);
  formData.append("CandidateDOB", payload.CandidateDOB);
  formData.append("JobUID", payload.JobUID);
  formData.append("Token", payload.Token);

  return axios.post("/api/Jobs/VerifyCandidate", formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// Send Candidate API
export const EmpSendCandidate = async (payload) => {
  const formData = new FormData();

  formData.append("Token", payload.Token);
  formData.append("RequestID", payload.RequestID);
  formData.append("CurrentCTC", payload.CurrentCTC || "");
  formData.append("ExpectedCTC", payload.ExpectedCTC || "");
  formData.append("TotalExperience", payload.TotalExperience || "");
  formData.append("CurrentLocation", payload.CurrentLocation || "");
  formData.append("NoticePeriod", payload.NoticePeriod || "");
  formData.append("ReadytoRelocate", String(payload.ReadytoRelocate));
  formData.append("ReasonofLeaving", payload.ReasonofLeaving || "");
  formData.append("Remarks", payload.Remarks || "");

  if (payload.ResumeFile) {
    formData.append("ResumeFile", payload.ResumeFile);
  }

  return axios.post("/api/Jobs/SubmitCandidate", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};



// services/jobService.js
// Author: Harshada Bhavsar 28-8-2025
// API: Get Sent Candidates For Jobs 
export const getSentCandidateforJobEmp = async (jobUID) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/Candidate/GetCandidatesForJob", {
    token,
    jobUID,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 10-11-2025
// API: Get Sent Candidates For Jobs 
export const updateJobOpening = async (jobData) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Jobs/Employee/UpdateJobOpening", {
    ...jobData,
    token,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 11-11-2025
//  Fetch job interviewers by JobUID
export const getJobInterviewers = async (jobUID) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/Jobs/Employee/GetJobInterviewers", {
    token,
    jobUID,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 12-11-2025
//  delete job interviewers by JobUID
export const deleteJobInterviewer = async (jobUID, interviewerCode) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/Jobs/Employee/DeleteJobInterviewer", {
    token,
    jobUID,
    interviewerCode,
  });
};

// Author: Harshada Bhavsar 17-12-2025
//  Get Job Opening Limit by JobUID
export const getJobOpeningLimit = async (jobUID) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Jobs/GetJobOpeningLimit", {
    token,
    jobUID,
  });
};